export default __webpack_public_path__ + "static/ceHCyjuM-4cf57e41057c4d4541c24d1b4b660f40.svg";